import React from 'react';
import PropTypes from 'prop-types';
import SmallResourcePreview from 'components/Utils/SmallResourcePreview';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';

const AttachmentsViewer = (props) => (
  <div className="row attachments-viewer">
    <Title {...props} />
    <Attachments {...props} />
  </div>
);

const Title = ({ title, hideTitle }) =>
  !hideTitle && <span className="small-title">{title || 'Attachments'}</span>;

const Attachments = ({
  attachments,
  patient,
  title,
  onFetch,
  getFileInfo,
  fax,
  showFax,
  isPatient,
  document,
}) => {
  const dispatch = useAppDispatch();

  function getFile(attachment, dispatchOptions) {
    return onFetch
      ? onFetch(attachment, dispatchOptions)
      : dispatch(api.Resource.getResource({ resource: attachment }), dispatchOptions);
  }

  return (
    attachments &&
    (attachments || []).map((attachment) => (
      <SmallResourcePreview
        key={attachment}
        isPatient={isPatient}
        fax={fax}
        document={document}
        showFax={showFax}
        patient={patient}
        title={title}
        url={attachment}
        getFileInfo={getFileInfo}
        getFile={(dispatchOptions) => getFile(attachment, dispatchOptions)}
      />
    ))
  );
};

AttachmentsViewer.propTypes = {
  attachments: PropTypes.array,
  title: PropTypes.string,
  patient: PropTypes.object,
  hideTitle: PropTypes.bool,
  onFetch: PropTypes.func,
  getFileInfo: PropTypes.func,
  fax: PropTypes.string,
  showFax: PropTypes.bool,
  isPatient: PropTypes.bool,
  document: PropTypes.object,
};

export default AttachmentsViewer;
